<app-section-start></app-section-start>
<app-section-about></app-section-about>
<app-section-instructions></app-section-instructions>
<app-section-property></app-section-property>
